import { render, staticRenderFns } from "./ProductPageApp.vue?vue&type=template&id=15509c03"
import script from "./ProductPageApp.vue?vue&type=script&lang=js"
export * from "./ProductPageApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports